
import Spinner from './spinner'
import Bookmark from './bookmark'
import BookmarkHelper from '../mixins/bookmarkHelper'
import { focus } from 'vue-focus'
import Axios from 'axios'

const http = Axios.create({
  baseURL: '/select/api',
})

export default {
  name: 'bookmarks',
  created: function() {
    this._fetch()
  },
  components: { Bookmark, Spinner },
  mixins: [BookmarkHelper],
  directives: { focus },
  data: function() {
    return {
      bookmarks: [],
      removedBookmark: {},
      magazines: [],
      magazine: undefined,
      filter: undefined,
      fetching: true,
      focus: false,
    }
  },
  computed: {
    bookmarksAvailable: function() {
      return this.bookmarks.length && !this.fetching
    },
    bookmarksCount: function() {
      return this.bookmarks.length
    },
    undoAvailable: function() {
      return Object.keys(this.removedBookmark).length
    }
  },
  methods: {
    save: function(bookmark) {
      const bookmarksCached = this.bookmarks
      http.patch('bookmarks/' + bookmark.magazine + '/' + bookmark.id,
        { comment: bookmark.comment })
        .catch(err => {
          this.bookmarks = bookmarksCached
          console.error('Bookmark konnte nicht gespeichert werden!', err)
        })
    },
    restore: function(bookmark) {
      const oldBookmark = this.bookmarks.filter(b => b.id === bookmark.id)[0]
      const oldBookmarkIndex = this.bookmarks.indexOf(oldBookmark)
      this.createBookmark(
        bookmark.magazine,
        bookmark.issue_id,
        bookmark.container_id
      ).then(response => {
        const newBookmark = response.data
        newBookmark.comment = bookmark.comment
        this.bookmarks.splice(oldBookmarkIndex, 1, newBookmark)
        this.save(newBookmark)
      }).catch(err => {
        console.error('Bookmark konnte nicht wiederhergestellt werden!', err)
      })
    },
    remove: function(bookmark) {
      const bookmarksCached = this.bookmarks
      let removedBookmark = bookmark
      const index = this.bookmarks.indexOf(bookmark)
      removedBookmark.deleted = true
      this.bookmarks.splice(index, 1, removedBookmark)
      http.delete('bookmarks/' + bookmark.magazine + '/' + bookmark.id)
        .catch(err => {
          this.bookmarks = bookmarksCached
          removedBookmark = {}
          console.error('Bookmark konnte nicht gelöscht werden!', err)
        })
      this.focus = false
    },
    _markAsDeleted: function (bookmark) {
      for (const i in this.bookmarks) {
        if (this.bookmarks[i].id === bookmark.id) {
          this.bookmarks[i].deleted = true
          break
        }
      }
    },
    _fetch: function() {
      Promise.all([
        http.get('bookmarks')
          .then(response => {
            this.bookmarks = response.data
          })
          .catch(err => {
            console.error('Bookmarks konnten nicht abgefragt werden!', err)
          }),
        http.get('magazines')
          .then(response => {
            this.magazines = response.data
          })
          .catch(err => {
            console.error('Magazine konnten nicht abgefrafgt werden!', err)
          })
      ]).then(() => {
        this.fetching = false
      })
    },
    filteredBookmarks: function() {
      let bookmarks = this.bookmarks
      if (typeof this.magazine !== 'undefined') {
        bookmarks = this._filterByMagazine(bookmarks)
      }
      if (typeof this.filter !== 'undefined') {
        bookmarks = this._filterBySearchterm(bookmarks)
      }
      return bookmarks
    },
    _filterBySearchterm: function(bookmarks) {
      const pattern = new RegExp(this.filter, 'i')
      return bookmarks.filter(bookmark => {
        const searchIndex = ['title', 'keywords', 'subtitle', 'comment', 'category']
          .map((key) => bookmark[key])
          .join('|')
        return pattern.test(searchIndex)
      })
    },
    _filterByMagazine: function(bookmarks) {
      return bookmarks.filter(bookmark => bookmark.magazine === this.magazine)
    },
    magazineForBookmark: function(bookmark) {
      return this.magazines.filter(
        magazine => magazine.url_name === bookmark.magazine
      )[0]
    },
    magazineHasBookmark: function(magazine) {
      return this.bookmarks.filter(
        bookmark => bookmark.magazine === magazine.url_name
      ).length
    }
  }
}
